// Espelho dos enums do PG (dev_request_*_t) e do contrato JSON da API /dev-requests.
export enum DevRequestStatus {
  pending = 'pending',
  inProgress = 'in_progress',
  waitingSupport = 'waiting_support',
  waitingApproval = 'waiting_approval',
  waitingMigration = 'waiting_migration',
  completed = 'completed',
  delivered = 'delivered',
  resolved = 'resolved',
  failed = 'failed',
  canceled = 'canceled',
}

export enum DevRequestType {
  feature = 'feature',
  bug = 'bug',
  investigation = 'investigation',
  task = 'task', // tarefa: não é funcionalidade, bug nem investigação (ex.: alterar dados no banco)
}

export enum DevRequestLane {
  urgent = 'urgent',
  resume = 'resume',
  normal = 'normal',
}

export enum DevRequestAction {
  send = 'send',
  answer = 'answer',
  approve = 'approve',
  reject = 'reject',
  migrated = 'migrated',
  resolve = 'resolve',
  reopen = 'reopen',
  retry = 'retry',
  cancel = 'cancel',
  comment = 'comment',
}

export enum DevRequestEventType {
  created = 'created',
  edited = 'edited',
  claimed = 'claimed',
  claudeRun = 'claude_run',
  question = 'question',
  answer = 'answer',
  approvalRequested = 'approval_requested',
  approved = 'approved',
  rejected = 'rejected',
  mergedDevelop = 'merged_develop',
  migrationPending = 'migration_pending',
  migrationConfirmed = 'migration_confirmed',
  deployStarted = 'deploy_started',
  deployOk = 'deploy_ok',
  deployFailed = 'deploy_failed',
  completed = 'completed',
  delivered = 'delivered',
  resolved = 'resolved',
  reopened = 'reopened',
  canceled = 'canceled',
  failed = 'failed',
  retry = 'retry',
  stale = 'stale',
  error = 'error',
  comment = 'comment',
  note = 'note',
  statusChanged = 'status_changed',
  sent = 'sent',
}

export interface DevRequestRun {
  id: number;
  workflowName: string;
  url: string;
  status: string;
  conclusion: string | null;
}

export interface DevRequestProject {
  repo: string;
  githubRepo: string;
  branch: string;
  worktree?: string;
  commits: { sha: string; message: string; url: string }[];
  developPrUrl?: string;
  developMergeSha?: string;
  deployPrUrl?: string;
  deploySha?: string;
  runs?: DevRequestRun[];
  deployKind: 'actions' | 'manual' | 'store';
  deployStatus: 'pending' | 'merged_develop' | 'deploying' | 'success' | 'failed' | 'manual' | 'store';
  deployAttempts: number;
}

export interface DevRequestEvent {
  id: string;
  devRequestId: string;
  type: DevRequestEventType;
  actor: string;
  message: string | null;
  payload: unknown;
  durationMs: number | null;
  costUsd: number | null;
  createdAt: string;
}

export interface DevRequest {
  resumeReason?: string | null;
  sentAt?: string | null;
  /** Só no GET do pedido: exatamente o que o robô lê. O suporte confere antes de confirmar. */
  requestMd?: string;
  /** Só no GET do pedido: as imagens que o robô vai ler. */
  imageSrcs?: string[];
  /** Só no GET do pedido: a tela devolve ao enviar, para o backend recusar texto alterado depois de lido. */
  contentSha?: string;
  id: string;
  number: number;
  title: string;
  body?: string;
  type: DevRequestType;
  urgent: boolean;
  chainId: string | null;
  referenceUrl: string | null;
  requesterName: string | null;
  status: DevRequestStatus;
  questions: string | null;
  answers: string | null;
  approvalReason: string | null;
  approvalNote: string | null;
  summary: string | null;
  rootCause: string | null;
  devNotes: string | null;
  assumptions: string | null;
  requiresAppUpdate: boolean;
  appUpdateNotes: string | null;
  projects: DevRequestProject[];
  migrationSql: string | null;
  migrationDiff: string | null;
  migrationDiffSha: string | null;
  migrationDiffUrl: string | null;
  sessionId: string | null;
  attemptCount: number;
  failureCount: number;
  lastError: string | null;
  createdAt: string;
  events?: DevRequestEvent[];
  totals?: { costUsd: number; claudeMs: number; runs: number };
}

export interface DevRequestWorker {
  id: DevRequestLane;
  lane: DevRequestLane;
  workerId: string;
  lastSeenAt: string;
  lastNote: string | null;
  lastClaimedId: string | null;
  /** Pedido em que a fila está trabalhando: enquanto isso ela não dá sinal, o heartbeat do pedido é que diz se está viva. */
  busy?: { id: string; number: number; since: string | null; heartbeatAt: string | null } | null;
}
